import { createFileRoute, redirect } from '@tanstack/react-router'
import { CATEGORIES_PAGE_READ, CATEGORIES_TABS } from '~/components/routes/categories/tabs'
import { withRoutePermissions } from '~/utils/rbac'
import { firstAuthorizedScreen } from '~/utils/rbacModuleIndex'

// Chaque onglet est une URL distincte ; `/categories` n'a pas de contenu propre et redirige vers le
// premier onglet accessible. La page est donc ouverte dès qu'AU MOINS UN sous-onglet l'est
// (`{ any }`), et `withRoutePermissions` refuse l'accès quand aucun ne l'est.
export const Route = createFileRoute('/_authenticated/categories/')({
  staticData: {
    permission: CATEGORIES_PAGE_READ,
  },
  beforeLoad: ({ context }) => {
    const firstAuthorized = firstAuthorizedScreen(context.ability, CATEGORIES_TABS)

    // `withRoutePermissions` a déjà refusé l'accès si aucun écran du module ne l'est. Un rôle qui
    // n'a qu'une création (`add`) n'a aucun onglet lisible : il atterrit sur le premier, dont la
    // barre d'onglets et les affordances restent gardées une à une.
    throw redirect({ to: firstAuthorized?.to ?? CATEGORIES_TABS[0].to })
  },
})
withRoutePermissions(Route)
